import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header";
import { Userlogin } from "../Utils/general-function";
import Finance from "tvm-financejs";
export const LoanEmi = () => {
  const [inputVal, setInput] = useState({
    interestRate: 7,
    months: 12,
    loanAmount: 100000,
    show: false,

    // result

    //reduce interest rate
    monthlyEmi: "",
    totalPayment: "",
    totalInterest: "",

    //flat interest rate
    monthlyEmi2: "",
    totalPayment2: "",
    totalInterest2: "",
  });

  // GLOBAL VARIABLE
  const navigate = useNavigate();
  const financejs = new Finance();

  //METHOD
  useEffect(() => {
    if (!Userlogin()) navigate("/Login");
    onSubmit(inputVal);
  }, []);

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setInput((preVal) => ({ ...preVal, [name]: value }));
    let latestVal = {
      ...inputVal,
      [name]: value,
    };
    onSubmit(latestVal);
  };
  const onMonthChange = (e) => {
    const { name, value } = e.target;

    const whole = isNaN(parseInt(value)) ? "" : parseInt(value); // removes any decimal part

    setInput((preVal) => ({ ...preVal, [name]: whole }));
    let latestVal = {
      ...inputVal,
      [name]: whole,
    };
    onSubmit(latestVal);
  };

  const onSubmit = (latestVal) => {
    // REDUCING INTEREST RATE
    let ratePF = parseFloat(latestVal.interestRate || 0) / 100 / 12; //monthly rate
    let months = parseFloat(latestVal.months || 0);
    let loanAmtPF = parseFloat(latestVal.loanAmount || 0);
    let emi = financejs.PMT(ratePF, months, -loanAmtPF, 0, 0);
    let totalPayment = emi * months;
    let totalInterest = totalPayment - loanAmtPF;

    // FLAT INTEREST RATE
    let ratePF2 = parseFloat(latestVal.interestRate || 0) / 100; // convert into decimal
    let year2 = parseFloat(latestVal.months || 0) / 12; //convert into year

    let totalInterest2 = loanAmtPF * ratePF2 * year2;
    let totalPayment2 = loanAmtPF + totalInterest2;
    let emi2 = totalPayment2 / (year2 * 12); // for monthly emi

    setInput((prevVal) => ({
      ...prevVal,
      monthlyEmi: emi,
      totalPayment,
      totalInterest,
      monthlyEmi2: emi2,
      totalPayment2,
      totalInterest2,
      show: true,
    }));
  };

  const rupeeFormat = (rs) =>
    rs.toLocaleString("en-IN", {
      maximumFractionDigits: 0,
      style: "currency",
      currency: "INR",
    });

  return (
    <>
      <Header />
      <div className="page-space">
        <div className="text-center">
          <h2 className="page-title">EMI Calculation</h2>
        </div>

        {/* input */}
        <div>
          <div style={{ margin: "12px 0px" }}>
            <div className="form-div">
              <div className="d-flex justify-content-between align-items-center mb-3 gap-2">
                <label className="form-label m-0">Loan Amount (₹) </label>
                <input
                  type="number"
                  min="100000"
                  max="3000000"
                  step="50000"
                  className="range-slider-value-text range-slider-text2"
                  name="loanAmount"
                  value={inputVal.loanAmount}
                  range-slider-value-text
                  onChange={onInputChange}
                />
              </div>
            </div>
            <div className="form-div">
              <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
                <label className="form-label">Interest rate (Per year)</label>
                <span className="range-slider-value">
                  <input
                    type="number"
                    name="interestRate"
                    autoComplete="off"
                    className="range-slider-value-text range-slider-text1"
                    value={inputVal.interestRate}
                    onChange={onInputChange}
                    min="7"
                    max="20"
                  />
                </span>
              </div>
            </div>
            <div className="form-div">
              <div className="d-flex justify-content-between mb-3 align-items-center gap-2">
                <label className="form-label">Loan Tenure (Months) </label>
                <span className="range-slider-value">
                  <input
                    type="number"
                    autoComplete="off"
                    className="range-slider-value-text range-slider-text1"
                    value={inputVal.months}
                    min="12"
                    step={1}
                    name="months"
                    onChange={onMonthChange}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex flex-column result">
          {/* <h2 className="text-center">Flat interest rate</h2> */}
          <div
            className="d-flex justify-content-between align-items-center flex-wrap"
            style={{
              padding: "10px",
              borderBottom: "2px solid #fff",
              borderRadius: "12px",
            }}
          >
            <span className="emi-eq-width m-0"></span>
            <h3 className="emi-eq-width textRed m-0">Flat interest rate</h3>
            <h3 className="emi-eq-width textRed m-0">Reducing interest rate</h3>
          </div>

          <div
            className="d-flex justify-content-between align-items-center flex-wrap"
            style={{
              // padding: "5px",
              fontSize: "15px",
            }}
          >
            <p className="emi-eq-width m-0">Monthly Payment</p>
            <p className="emi-eq-width textRed m-0">
              {rupeeFormat(inputVal.monthlyEmi2 || 0)}
            </p>
            <p className="emi-eq-width textRed m-0">
              {rupeeFormat(inputVal.monthlyEmi || 0)}
            </p>
          </div>
          <div
            className="text-center d-flex justify-content-between align-items-center flex-wrap"
            style={{
              // padding: "5px",
              fontSize: "15px",
            }}
          >
            <p className="emi-eq-width m-0">Total Payment</p>
            <p className="emi-eq-width textRed m-0">
              {rupeeFormat(inputVal.totalPayment2 || 0)}
            </p>{" "}
            <p className=" emi-eq-width textRed m-0">
              {rupeeFormat(inputVal.totalPayment || 0)}
            </p>
          </div>
          <div
            className="text-center d-flex justify-content-between align-items-center"
            style={{
              padding: "0px 5px 10px 5px",
              fontSize: "15px",
            }}
          >
            <p className="emi-eq-width m-0">Total Interest</p>
            <p className="emi-eq-width textRed m-0">
              {rupeeFormat(inputVal.totalInterest2 || 0)}
            </p>
            <p className="emi-eq-width m-0">
              {" "}
              {rupeeFormat(inputVal.totalInterest || 0)}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
